// Chargeur de drapeaux SVG pour tous les pays
// Ce fichier charge tous les drapeaux disponibles de manière statique

// Imports de tous les drapeaux disponibles dans country-flag-icons
// Note: Webpack nécessite des imports statiques, donc nous devons importer tous les drapeaux
import AF from 'country-flag-icons/react/3x2/AF';
import ZA from 'country-flag-icons/react/3x2/ZA';
import AL from 'country-flag-icons/react/3x2/AL';
import DZ from 'country-flag-icons/react/3x2/DZ';
import DE from 'country-flag-icons/react/3x2/DE';
import AD from 'country-flag-icons/react/3x2/AD';
import AO from 'country-flag-icons/react/3x2/AO';
import AG from 'country-flag-icons/react/3x2/AG';
import SA from 'country-flag-icons/react/3x2/SA';
import AR from 'country-flag-icons/react/3x2/AR';
import AM from 'country-flag-icons/react/3x2/AM';
import AU from 'country-flag-icons/react/3x2/AU';
import AT from 'country-flag-icons/react/3x2/AT';
import AZ from 'country-flag-icons/react/3x2/AZ';
import BS from 'country-flag-icons/react/3x2/BS';
import BH from 'country-flag-icons/react/3x2/BH';
import BD from 'country-flag-icons/react/3x2/BD';
import BB from 'country-flag-icons/react/3x2/BB';
import BE from 'country-flag-icons/react/3x2/BE';
import BZ from 'country-flag-icons/react/3x2/BZ';
import BJ from 'country-flag-icons/react/3x2/BJ';
import BT from 'country-flag-icons/react/3x2/BT';
import BY from 'country-flag-icons/react/3x2/BY';
import BO from 'country-flag-icons/react/3x2/BO';
import BA from 'country-flag-icons/react/3x2/BA';
import BW from 'country-flag-icons/react/3x2/BW';
import BR from 'country-flag-icons/react/3x2/BR';
import BN from 'country-flag-icons/react/3x2/BN';
import BG from 'country-flag-icons/react/3x2/BG';
import BF from 'country-flag-icons/react/3x2/BF';
import BI from 'country-flag-icons/react/3x2/BI';
import KH from 'country-flag-icons/react/3x2/KH';
import CM from 'country-flag-icons/react/3x2/CM';
import CA from 'country-flag-icons/react/3x2/CA';
import CV from 'country-flag-icons/react/3x2/CV';
import CF from 'country-flag-icons/react/3x2/CF';
import TD from 'country-flag-icons/react/3x2/TD';
import CL from 'country-flag-icons/react/3x2/CL';
import CN from 'country-flag-icons/react/3x2/CN';
import CO from 'country-flag-icons/react/3x2/CO';
import KM from 'country-flag-icons/react/3x2/KM';
import CG from 'country-flag-icons/react/3x2/CG';
import CD from 'country-flag-icons/react/3x2/CD';
import KP from 'country-flag-icons/react/3x2/KP';
import KR from 'country-flag-icons/react/3x2/KR';
import CR from 'country-flag-icons/react/3x2/CR';
import CI from 'country-flag-icons/react/3x2/CI';
import HR from 'country-flag-icons/react/3x2/HR';
import CU from 'country-flag-icons/react/3x2/CU';
import CY from 'country-flag-icons/react/3x2/CY';
import CZ from 'country-flag-icons/react/3x2/CZ';
import DK from 'country-flag-icons/react/3x2/DK';
import DJ from 'country-flag-icons/react/3x2/DJ';
import DM from 'country-flag-icons/react/3x2/DM';
import EG from 'country-flag-icons/react/3x2/EG';
import AE from 'country-flag-icons/react/3x2/AE';
import EC from 'country-flag-icons/react/3x2/EC';
import ER from 'country-flag-icons/react/3x2/ER';
import ES from 'country-flag-icons/react/3x2/ES';
import EE from 'country-flag-icons/react/3x2/EE';
import SZ from 'country-flag-icons/react/3x2/SZ';
import US from 'country-flag-icons/react/3x2/US';
import ET from 'country-flag-icons/react/3x2/ET';
import FJ from 'country-flag-icons/react/3x2/FJ';
import FI from 'country-flag-icons/react/3x2/FI';
import FR from 'country-flag-icons/react/3x2/FR';
import GA from 'country-flag-icons/react/3x2/GA';
import GM from 'country-flag-icons/react/3x2/GM';
import GE from 'country-flag-icons/react/3x2/GE';
import GH from 'country-flag-icons/react/3x2/GH';
import GR from 'country-flag-icons/react/3x2/GR';
import GD from 'country-flag-icons/react/3x2/GD';
import GT from 'country-flag-icons/react/3x2/GT';
import GN from 'country-flag-icons/react/3x2/GN';
import GW from 'country-flag-icons/react/3x2/GW';
import GQ from 'country-flag-icons/react/3x2/GQ';
import GY from 'country-flag-icons/react/3x2/GY';
import HT from 'country-flag-icons/react/3x2/HT';
import HN from 'country-flag-icons/react/3x2/HN';
import HU from 'country-flag-icons/react/3x2/HU';
import IN from 'country-flag-icons/react/3x2/IN';
import ID from 'country-flag-icons/react/3x2/ID';
import IR from 'country-flag-icons/react/3x2/IR';
import IQ from 'country-flag-icons/react/3x2/IQ';
import IE from 'country-flag-icons/react/3x2/IE';
import IS from 'country-flag-icons/react/3x2/IS';
import IL from 'country-flag-icons/react/3x2/IL';
import IT from 'country-flag-icons/react/3x2/IT';
import JM from 'country-flag-icons/react/3x2/JM';
import JP from 'country-flag-icons/react/3x2/JP';
import JO from 'country-flag-icons/react/3x2/JO';
import KZ from 'country-flag-icons/react/3x2/KZ';
import KE from 'country-flag-icons/react/3x2/KE';
import KG from 'country-flag-icons/react/3x2/KG';
import KI from 'country-flag-icons/react/3x2/KI';
import KW from 'country-flag-icons/react/3x2/KW';
import LA from 'country-flag-icons/react/3x2/LA';
import LS from 'country-flag-icons/react/3x2/LS';
import LV from 'country-flag-icons/react/3x2/LV';
import LB from 'country-flag-icons/react/3x2/LB';
import LR from 'country-flag-icons/react/3x2/LR';
import LY from 'country-flag-icons/react/3x2/LY';
import LI from 'country-flag-icons/react/3x2/LI';
import LT from 'country-flag-icons/react/3x2/LT';
import LU from 'country-flag-icons/react/3x2/LU';
import MK from 'country-flag-icons/react/3x2/MK';
import MG from 'country-flag-icons/react/3x2/MG';
import MY from 'country-flag-icons/react/3x2/MY';
import MW from 'country-flag-icons/react/3x2/MW';
import MV from 'country-flag-icons/react/3x2/MV';
import ML from 'country-flag-icons/react/3x2/ML';
import MT from 'country-flag-icons/react/3x2/MT';
import MA from 'country-flag-icons/react/3x2/MA';
import MH from 'country-flag-icons/react/3x2/MH';
import MR from 'country-flag-icons/react/3x2/MR';
import MU from 'country-flag-icons/react/3x2/MU';
import MX from 'country-flag-icons/react/3x2/MX';
import FM from 'country-flag-icons/react/3x2/FM';
import MD from 'country-flag-icons/react/3x2/MD';
import MC from 'country-flag-icons/react/3x2/MC';
import MN from 'country-flag-icons/react/3x2/MN';
import ME from 'country-flag-icons/react/3x2/ME';
import MZ from 'country-flag-icons/react/3x2/MZ';
import MM from 'country-flag-icons/react/3x2/MM';
import NA from 'country-flag-icons/react/3x2/NA';
import NR from 'country-flag-icons/react/3x2/NR';
import NP from 'country-flag-icons/react/3x2/NP';
import NI from 'country-flag-icons/react/3x2/NI';
import NE from 'country-flag-icons/react/3x2/NE';
import NG from 'country-flag-icons/react/3x2/NG';
import NO from 'country-flag-icons/react/3x2/NO';
import NZ from 'country-flag-icons/react/3x2/NZ';
import OM from 'country-flag-icons/react/3x2/OM';
import UG from 'country-flag-icons/react/3x2/UG';
import UZ from 'country-flag-icons/react/3x2/UZ';
import PK from 'country-flag-icons/react/3x2/PK';
import PW from 'country-flag-icons/react/3x2/PW';
import PA from 'country-flag-icons/react/3x2/PA';
import PG from 'country-flag-icons/react/3x2/PG';
import PY from 'country-flag-icons/react/3x2/PY';
import NL from 'country-flag-icons/react/3x2/NL';
import PE from 'country-flag-icons/react/3x2/PE';
import PH from 'country-flag-icons/react/3x2/PH';
import PL from 'country-flag-icons/react/3x2/PL';
import PT from 'country-flag-icons/react/3x2/PT';
import QA from 'country-flag-icons/react/3x2/QA';
import RO from 'country-flag-icons/react/3x2/RO';
import GB from 'country-flag-icons/react/3x2/GB';
import RU from 'country-flag-icons/react/3x2/RU';
import RW from 'country-flag-icons/react/3x2/RW';
import KN from 'country-flag-icons/react/3x2/KN';
import LC from 'country-flag-icons/react/3x2/LC';
import SM from 'country-flag-icons/react/3x2/SM';
import VC from 'country-flag-icons/react/3x2/VC';
import SB from 'country-flag-icons/react/3x2/SB';
import SV from 'country-flag-icons/react/3x2/SV';
import WS from 'country-flag-icons/react/3x2/WS';
import ST from 'country-flag-icons/react/3x2/ST';
import SN from 'country-flag-icons/react/3x2/SN';
import RS from 'country-flag-icons/react/3x2/RS';
import SC from 'country-flag-icons/react/3x2/SC';
import SL from 'country-flag-icons/react/3x2/SL';
import SG from 'country-flag-icons/react/3x2/SG';
import SK from 'country-flag-icons/react/3x2/SK';
import SI from 'country-flag-icons/react/3x2/SI';
import SO from 'country-flag-icons/react/3x2/SO';
import SD from 'country-flag-icons/react/3x2/SD';
import SS from 'country-flag-icons/react/3x2/SS';
import LK from 'country-flag-icons/react/3x2/LK';
import SE from 'country-flag-icons/react/3x2/SE';
import CH from 'country-flag-icons/react/3x2/CH';
import SR from 'country-flag-icons/react/3x2/SR';
import SY from 'country-flag-icons/react/3x2/SY';
import TJ from 'country-flag-icons/react/3x2/TJ';
import TZ from 'country-flag-icons/react/3x2/TZ';
import TH from 'country-flag-icons/react/3x2/TH';
import TL from 'country-flag-icons/react/3x2/TL';
import TG from 'country-flag-icons/react/3x2/TG';
import TO from 'country-flag-icons/react/3x2/TO';
import TT from 'country-flag-icons/react/3x2/TT';
import TN from 'country-flag-icons/react/3x2/TN';
import TM from 'country-flag-icons/react/3x2/TM';
import TR from 'country-flag-icons/react/3x2/TR';
import TV from 'country-flag-icons/react/3x2/TV';
import UA from 'country-flag-icons/react/3x2/UA';
import UY from 'country-flag-icons/react/3x2/UY';
import VU from 'country-flag-icons/react/3x2/VU';
import VA from 'country-flag-icons/react/3x2/VA';
import VE from 'country-flag-icons/react/3x2/VE';
import VN from 'country-flag-icons/react/3x2/VN';
import YE from 'country-flag-icons/react/3x2/YE';
import ZM from 'country-flag-icons/react/3x2/ZM';
import ZW from 'country-flag-icons/react/3x2/ZW';

// Map de tous les drapeaux SVG disponibles
export const FLAG_COMPONENTS = {
  'AF': AF, 'ZA': ZA, 'AL': AL, 'DZ': DZ, 'DE': DE, 'AD': AD, 'AO': AO, 'AG': AG,
  'SA': SA, 'AR': AR, 'AM': AM, 'AU': AU, 'AT': AT, 'AZ': AZ, 'BS': BS, 'BH': BH,
  'BD': BD, 'BB': BB, 'BE': BE, 'BZ': BZ, 'BJ': BJ, 'BT': BT, 'BY': BY, 'BO': BO,
  'BA': BA, 'BW': BW, 'BR': BR, 'BN': BN, 'BG': BG, 'BF': BF, 'BI': BI, 'KH': KH,
  'CM': CM, 'CA': CA, 'CV': CV, 'CF': CF, 'TD': TD, 'CL': CL, 'CN': CN, 'CO': CO,
  'KM': KM, 'CG': CG, 'CD': CD, 'KP': KP, 'KR': KR, 'CR': CR, 'CI': CI, 'HR': HR,
  'CU': CU, 'CY': CY, 'CZ': CZ, 'DK': DK, 'DJ': DJ, 'DM': DM, 'EG': EG, 'AE': AE,
  'EC': EC, 'ER': ER, 'ES': ES, 'EE': EE, 'SZ': SZ, 'US': US, 'ET': ET, 'FJ': FJ,
  'FI': FI, 'FR': FR, 'GA': GA, 'GM': GM, 'GE': GE, 'GH': GH, 'GR': GR, 'GD': GD,
  'GT': GT, 'GN': GN, 'GW': GW, 'GQ': GQ, 'GY': GY, 'HT': HT, 'HN': HN, 'HU': HU,
  'IN': IN, 'ID': ID, 'IR': IR, 'IQ': IQ, 'IE': IE, 'IS': IS, 'IL': IL, 'IT': IT,
  'JM': JM, 'JP': JP, 'JO': JO, 'KZ': KZ, 'KE': KE, 'KG': KG, 'KI': KI, 'KW': KW,
  'LA': LA, 'LS': LS, 'LV': LV, 'LB': LB, 'LR': LR, 'LY': LY, 'LI': LI, 'LT': LT,
  'LU': LU, 'MK': MK, 'MG': MG, 'MY': MY, 'MW': MW, 'MV': MV, 'ML': ML, 'MT': MT,
  'MA': MA, 'MH': MH, 'MR': MR, 'MU': MU, 'MX': MX, 'FM': FM, 'MD': MD, 'MC': MC,
  'MN': MN, 'ME': ME, 'MZ': MZ, 'MM': MM, 'NA': NA, 'NR': NR, 'NP': NP, 'NI': NI,
  'NE': NE, 'NG': NG, 'NO': NO, 'NZ': NZ, 'OM': OM, 'UG': UG, 'UZ': UZ, 'PK': PK,
  'PW': PW, 'PA': PA, 'PG': PG, 'PY': PY, 'NL': NL, 'PE': PE, 'PH': PH, 'PL': PL,
  'PT': PT, 'QA': QA, 'RO': RO, 'GB': GB, 'RU': RU, 'RW': RW, 'KN': KN, 'LC': LC,
  'SM': SM, 'VC': VC, 'SB': SB, 'SV': SV, 'WS': WS, 'ST': ST, 'SN': SN, 'RS': RS,
  'SC': SC, 'SL': SL, 'SG': SG, 'SK': SK, 'SI': SI, 'SO': SO, 'SD': SD, 'SS': SS,
  'LK': LK, 'SE': SE, 'CH': CH, 'SR': SR, 'SY': SY, 'TJ': TJ, 'TZ': TZ, 'TH': TH,
  'TL': TL, 'TG': TG, 'TO': TO, 'TT': TT, 'TN': TN, 'TM': TM, 'TR': TR, 'TV': TV,
  'UA': UA, 'UY': UY, 'VU': VU, 'VA': VA, 'VE': VE, 'VN': VN, 'YE': YE, 'ZM': ZM,
  'ZW': ZW
};

// Fonction pour charger un drapeau
export const loadFlag = (countryCode) => {
  return FLAG_COMPONENTS[countryCode] || null;
};

